/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React from 'react';
import {I18n} from 'react-redux-i18n';
import {get, toInteger, toLower} from 'lodash';
import Icon from '@material-ui/core/Icon';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import moment from '../../util/moment';

class DriverDetailsReport extends React.PureComponent {
  translateClassification = classification => {
    return I18n.t(`page.reports.column.${toLower(classification)}`);
  }
  renderEmpty() {
    const {isLoading, list} = this.props;
    if (!isLoading && list.length <= 0) {
      return (
        <TableRow>
          <TableCell>
            <span className="reports__infomsg">
              <Icon className="reports__infomsg-icon">info</Icon>
              {I18n.t('page.reports.emptyMessage')}
            </span>
          </TableCell>
        </TableRow>
      );
    }

    return null;
  }

  renderMediaDate(_mediaDate) {
    const mediaDate = toInteger(_mediaDate);
    if (!mediaDate) {
      return (<TableCell className="columnDate">--</TableCell>);
    }
    return (
      <TableCell className="columnDate">
        {moment(mediaDate).format(I18n.t('configuration.dateTimeFormat'))}
      </TableCell>
    );
  }

  render() {
    const {
      isLoading, list, showPrimary, showSecondary
    } = this.props;
    const showClassification = showPrimary || showSecondary;

    return (
      <React.Fragment>
        {!isLoading && (
          <Table id="reportHeaderTable" className="reports__tableheader">
            <TableHead>
              <TableRow>
                <TableCell colSpan="15">
                  <h2 id="reportTitle" className="reports__title">
                    {I18n.t('page.reports.videoSummaryDriverDetail')}
                  </h2>
                </TableCell>
              </TableRow>
              <TableRow className="table__head">
                <TableCell>{I18n.t('page.reports.column.driverName')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.driverID')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.vehicleNumber')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.dateTime')}</TableCell>
                <TableCell className="reports__tablerow-mediaid">{I18n.t('page.reports.column.mediaID')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.tagged')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.unreviewed')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.reviewed')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.review')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.reviewScore')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.reviewer')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.coachingComplete')}</TableCell>
                <TableCell className="reports__tablerow-comment">{I18n.t('page.reports.column.coachingComments')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.coach')}</TableCell>
                {showClassification &&
                <TableCell className="reports__tablerow-classification">
                  {I18n.t('page.reports.column.classification')}
                </TableCell>}
              </TableRow>
            </TableHead>
          </Table>
        )}
        {!isLoading && (
          <Table id="reportResultTable" className="reports__tablerow-headless">
            <TableBody>
              {this.renderEmpty()}
              {
                list.map((e, i) => (
                  <TableRow key={`details-${i}`} className={`reportRow reportRow_${i}`}>
                    <TableCell className="columnDriverName">{get(e, 'driverName', '--')}</TableCell>
                    <TableCell className="columnDriverLogin">{get(e, 'driverLogin', '--')}</TableCell>
                    <TableCell className="columnVehicle">{get(e, 'vehicle', '--')}</TableCell>
                    {this.renderMediaDate(e.mediaDate)}
                    <TableCell className="reports__tablerow-mediaid">
                      <a href="javascript:;" onClick={this.props.redirectMedia(e.mediaId)}>{e.mediaId}</a>
                    </TableCell>
                    <TableCell className="columnTagged">{get(e, 'tag.review.value', false) ? I18n.t('defaults.yes') : I18n.t('defaults.no')}</TableCell>
                    <TableCell className="columnUnReviewed">{get(e, 'review', false) ? I18n.t('defaults.no') : I18n.t('defaults.yes')}</TableCell>
                    <TableCell className="columnReviewed">{get(e, 'review', false) ? I18n.t('defaults.yes') : I18n.t('defaults.no')}</TableCell>
                    <TableCell className="columnReview">{get(e, 'review.description', '')}</TableCell>
                    <TableCell className="columnReviewScore">{get(e, 'review.points', '')}</TableCell>
                    <TableCell className="columnReviewer">{get(e, 'review.reviewerName', '--')}</TableCell>
                    <TableCell className="columnCoachCompleted">{get(e, 'coach.completed', false) ? I18n.t('defaults.yes') : I18n.t('defaults.no')}</TableCell>
                    <TableCell className="reports__tablerow-comment">{get(e, 'coach.comment', '')}</TableCell>
                    <TableCell className="columnCoach">{get(e, 'coach.coachName', '--')}</TableCell>
                    {showClassification &&
                    <TableCell className="reports__tablerow-classification">
                      {this.translateClassification(get(e, 'classification', '-'))}
                    </TableCell>
                    }
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        )}
      </React.Fragment>
    );
  }
}

export default DriverDetailsReport;
